var exports = {
  "kL": "xe564cbfb--f93a4a--container",
  "nf": "xe564cbfb--f93a4a--link",
  "Kk": "xe564cbfb--f93a4a--icon",
};

module.exports = exports;
